// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Atoms
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import FormDialog from 'atoms/FormDialog'
import TextInput from 'atoms/TextInput'

export default class CustomerFieldAddDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.open && nextProps.open !== prevState.open) {
      return CustomerFieldAddDialog.getDefaultState(nextProps)
    }
    return { open: nextProps.open }
  }

  static getDefaultState = ({ open }) => {
    return {
      open,
      label: ''
    }
  }

  constructor(props) {
    super()
    this.state = CustomerFieldAddDialog.getDefaultState(props)
  }

  handleSubmit = () => {
    const { onSubmit } = this.props
    const { label } = this.state
    onSubmit({ label })
  }

  handleLabelSave = (label) => {
    this.setState({ label })
  }

  render() {
    const { label } = this.state
    return (
      <FormDialog
        {...this.props}
        title="Add field"
        onSubmit={this.handleSubmit}
        applyButton={<Button>Confirm</Button>}
        cancelButton={<Button>Cancel</Button>}
      >
        <DialogContent>
          <TextInput
            required
            withBorder
            maxLength={30}
            placeholder="Enter label here..."
            defaultValue={label}
            onSave={this.handleLabelSave}
          />
        </DialogContent>
      </FormDialog>
    )
  }
}
